import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  Context,
  newNotificationPath,
  editNotificationPath,
  copyNotificationPath,
  destroyNotification,
  fetchClasses,
  fetchNotifications,
} from "../../../managerStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import NotificationList from "../../../templates/manager/NotificationList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    dispatch(fetchNotifications());
    dispatch(fetchClasses(currentYear));
  }, [dispatch, currentYear]);

  const toBuildNewNotification = React.useCallback(
    () => history.push(newNotificationPath),
    [history],
  );
  const toEditNotification = React.useCallback(
    (id: number) => history.push(`${editNotificationPath}/${id}`),
    [history],
  );
  const toCopyNotification = React.useCallback(
    (id: number) => history.push(`${copyNotificationPath}/${id}`),
    [history],
  );
  const deleteNotification = React.useCallback(
    (id: number) => {
      dispatch(peep(destroyNotification(id)));
    },
    [dispatch, peep],
  );

  return (
    <div>
      <Breadcrumb currentTitle={titles.notifications} />
      <NotificationList
        title={titles.notifications}
        calling={calling}
        classes={state.classes}
        toCopyNotification={toCopyNotification}
        toBuildNewNotification={toBuildNewNotification}
        toEditNotification={toEditNotification}
        deleteNotification={deleteNotification}
        notifications={state.notifications}
      />
    </div>
  );
};
